<div [ngClass]= "[textClass]">
    <ng-content></ng-content>
</div>
